export function numberWithCommas(x: string): string {
  var x = Number.parseFloat(x).toFixed(2)
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function numberWithCommasZero(x: string): string {
  var x = Number.parseFloat(x).toFixed(0)
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
